(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-vn-navigation]:not([data-vn-ready])').forEach(header => {
      header.dataset.vnReady = 'true';
      const nav = header.querySelector('.ds-nav');
      const toggle = header.querySelector('[data-menu-toggle]');
      const backdrop = header.parentElement.querySelector('[data-vn-backdrop]');
      const regionDialog = document.querySelector('[data-store-regions]');
      const groups = [...nav.querySelectorAll(':scope > details, :scope > [data-nav-split] > details')];
      const mobile = matchMedia('(max-width: 1100px)');
      const desktopHover = matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');
      const upcoming = nav.querySelector('[data-vn-upcoming]');
      const openLabel = toggle.getAttribute('aria-label');
      const summaries = groups.map(group => group.querySelector('summary'));
      let hoverCloseTimer;
      const cancelHoverClose = () => clearTimeout(hoverCloseTimer);
      const sync = () => {
        const expanded = nav.classList.contains('is-open') && mobile.matches;
        const active = expanded || groups.some(group => group.open);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.setAttribute('aria-label', expanded ? window.storeTranslate('s004') : openLabel);
        summaries.forEach((summary, index) => summary.setAttribute('aria-expanded', String(groups[index].open)));
        if (backdrop) backdrop.hidden = !active;
        document.documentElement.classList.toggle('vn-mobile-nav-open', expanded);
      };
      const closeGroups = () => {
        cancelHoverClose();
        groups.forEach(group => { group.open = false; });
        if (upcoming) upcoming.open = false;
      };
      const closeAll = () => { closeGroups(); nav.classList.remove('is-open'); sync(); };
      const openGroup = group => {
        cancelHoverClose();
        groups.forEach(other => { other.open = other === group; });
        sync();
      };
      groups.forEach(group => {
        const groupScope = group.closest('[data-nav-split]') || group;
        groupScope.addEventListener('pointerenter', event => {
          if (desktopHover.matches && event.pointerType === 'mouse') openGroup(group);
        });
        groupScope.addEventListener('pointerleave', event => {
          if (!desktopHover.matches || event.pointerType !== 'mouse') return;
          cancelHoverClose();
          // Allow travel from the trigger into its panel without a flicker.
          hoverCloseTimer = setTimeout(() => {
            if (!groupScope.querySelector(':focus-visible')) {
              group.open = false;
              sync();
            }
          }, 180);
        });
        groupScope.addEventListener('focusin', cancelHoverClose);
        group.querySelector('summary').addEventListener('click', event => {
          if (!desktopHover.matches || event.pointerType !== 'mouse' || event.detail === 0) return;
          event.preventDefault();
          openGroup(group);
        });
      });
      nav.querySelectorAll(':scope > a').forEach(link => link.addEventListener('pointerenter', event => {
        if (desktopHover.matches && event.pointerType === 'mouse') { closeGroups(); sync(); }
      }));
      toggle.addEventListener('click', () => {
        const open = !nav.classList.contains('is-open');
        closeGroups();
        nav.classList.toggle('is-open', open);
        if (open) nav.scrollTop = 0;
        sync();
      });
      groups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
        else group.querySelectorAll('details[open]').forEach(child => { child.open = false; });
        sync();
      }));
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        cancelHoverClose();
        if (upcoming?.open) {
          event.preventDefault();
          upcoming.open = false;
          upcoming.querySelector('summary').focus();
          return;
        }
        const open = groups.find(group => group.open);
        if (open) {
          event.preventDefault();
          open.open = false;
          open.querySelector('summary').focus();
          sync();
        } else if (nav.classList.contains('is-open')) {
          event.preventDefault();
          closeAll();
          toggle.focus();
        }
      });
      header.addEventListener('focusout', event => {
        if (regionDialog?.contains(event.relatedTarget)) return;
        if (event.relatedTarget && !header.contains(event.relatedTarget)) closeAll();
        else if (!mobile.matches) groups.forEach(group => {
          const groupScope = group.closest('[data-nav-split]') || group;
          if (groupScope.contains(event.target) && event.relatedTarget && !groupScope.contains(event.relatedTarget)) group.open = false;
        });
      });
      document.addEventListener('click', event => { if (!header.contains(event.target) && !regionDialog?.contains(event.target)) closeAll(); });
      nav.addEventListener('click', event => { if (event.target.closest('a')) closeAll(); });
      mobile.addEventListener('change', closeAll);
      desktopHover.addEventListener('change', closeAll);
      window.addEventListener('blur', () => { if (!mobile.matches) closeAll(); });
      const rail = header.querySelector('.bb-mega-grid');
      const previous = header.querySelector('[data-vn-rail-prev]');
      const next = header.querySelector('[data-vn-rail-next]');
      if (rail && previous && next) {
        const updateRail = () => {
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        const moveRail = direction => {
          const card = rail.querySelector('a');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
          rail.scrollBy({ left:direction * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => moveRail(-1));
        next.addEventListener('click', () => moveRail(1));
        rail.addEventListener('scroll', updateRail, { passive:true });
        rail.addEventListener('focusin', event => {
          const card = event.target.closest('a');
          if (!card?.matches(':focus-visible')) return;
          requestAnimationFrame(() => {
            if (document.activeElement === card) card.scrollIntoView({ block:'nearest', inline:'nearest', behavior:'instant' });
          });
        });
        new ResizeObserver(updateRail).observe(rail);
        updateRail();
      }
      const measure = () => document.documentElement.style.setProperty('--vn-header-height', `${header.getBoundingClientRect().height}px`);
      new ResizeObserver(measure).observe(header);
      measure();
      sync();
    });
    scope.querySelectorAll('[data-store-film]:not([data-vn-ready])').forEach(section => {
      section.dataset.vnReady = 'true';
      const video = section.querySelector('video');
      const status = section.querySelector('[data-vn-film-status]');
      if (!video || !status) return;
      video.addEventListener('error', () => { status.hidden = false; });
      video.querySelectorAll('source').forEach(source => source.addEventListener('error', () => {
        if (video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE || video.querySelectorAll('source').length === 1) status.hidden = false;
      }));
      video.addEventListener('loadeddata', () => { status.hidden = true; });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
